import { HttpInterceptorFn } from '@angular/common/http';

export const noCacheInterceptor: HttpInterceptorFn = (req, next) => {
  const noCacheReq = req.clone({
    setHeaders: {
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      'Pragma': 'no-cache',
      'Expires': '0'
    },
    setParams: {
      'v': Date.now().toString(36) // Converts to base-36: shorter, alphanumeric
    }
  });
  
  return next(noCacheReq);
};